// Registers the service worker in production so the dashboard installs as an
// app and loads instantly. Tells the app when a newer build is waiting so it
// can offer a reload — the worker never serves API data, so "stale" only ever
// means the app shell, never the numbers.
export function register(config = {}) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swUrl)
      .then((registration) => {
        // A build already waiting from a previous visit
        if (registration.waiting && navigator.serviceWorker.controller) config.onUpdate?.(registration);
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state !== 'installed') return;
            if (navigator.serviceWorker.controller) config.onUpdate?.(registration);
            else config.onSuccess?.(registration);
          };
        };
      })
      .catch((err) => console.warn('Service worker not registered:', err));
  });
}

// Ask the waiting worker to take over, then reload once it has
export function applyUpdate(registration) {
  const waiting = registration?.waiting;
  if (!waiting) { window.location.reload(); return; }
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
  waiting.postMessage({ type: 'SKIP_WAITING' });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {});
  }
}
